var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "histo", staticStyle: { height: "100%" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "", height: _vm.chatHeight } },
        [
          _c(
            "v-card",
            {
              staticStyle: { "z-index": "1000000", position: "absolute" },
              attrs: { width: "320", height: "100%", absolute: "" }
            },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "white",
                  attrs: { flat: "", dense: "", extended: "" }
                },
                [_c("v-toolbar-title")],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-form",
                [
                  _c(
                    "v-container",
                    { attrs: { left: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.default_motif,
                                  label: "Motif de la conversation"
                                },
                                on: { change: _vm.showValidButton },
                                model: {
                                  value: _vm.convMotif,
                                  callback: function($$v) {
                                    _vm.convMotif = $$v
                                  },
                                  expression: "convMotif"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  items: _vm.default_qualif,
                                  label: "Qualifier la conversation"
                                },
                                on: { change: _vm.showValidButton },
                                model: {
                                  value: _vm.convQualif,
                                  callback: function($$v) {
                                    _vm.convQualif = $$v
                                  },
                                  expression: "convQualif"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.validButton
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", left: "" },
                      on: {
                        click: function($event) {
                          return _vm.submitEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.toolbar
            ? _c(
                "v-toolbar",
                {
                  staticClass: "primary",
                  class: { "histo__navigation--opened": true },
                  attrs: { dark: "", dense: "", extended: "" }
                },
                [
                  _c("v-toolbar-side-icon"),
                  _vm._v(" "),
                  _c("v-toolbar-title", { staticClass: "white--text" }, [
                    _vm._v("Conversation n° " + _vm._s(_vm.params))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "white--text subheading",
                      attrs: { slot: "extension" },
                      slot: "extension"
                    },
                    [
                      _c("v-tooltip", { attrs: { right: "" } }, [
                        _c(
                          "span",
                          {
                            staticClass: "mr-3",
                            attrs: { slot: "activator" },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { dark: "" } }, [
                              _vm._v("access_time")
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dateConv) +
                                "\n          "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Date")])
                      ]),
                      _vm._v(" "),
                      _c("v-tooltip", { attrs: { right: "" } }, [
                        _c(
                          "span",
                          { attrs: { slot: "activator" }, slot: "activator" },
                          [
                            _c("v-icon", { attrs: { dark: "" } }, [
                              _vm._v("timer")
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dureeConv) +
                                "\n          "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Durée totale")])
                      ]),
                      _vm._v(" "),
                      _c("v-tooltip", { attrs: { right: "" } }, [
                        _c(
                          "span",
                          { attrs: { slot: "activator" }, slot: "activator" },
                          [
                            _c("v-icon", { attrs: { dark: "", right: "" } }, [
                              _vm._v("chat_bubble_outline")
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.nbBulles) +
                                "\n          "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Nb de boutons cliqués / messages saisis")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "main",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              ref: "contentChat",
              class: {
                "histo__navigation--opened vb": true,
                "histo__main--toolbar vb": _vm.toolbar,
                "histo__main--no-toolbar vb": !_vm.toolbar
              },
              staticStyle: { height: "100%" },
              attrs: { id: "contentChat" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "histo__main--scroll",
                  attrs: { "grid-list-sm": "", fluid: "" }
                },
                [
                  _vm.loading
                    ? _c(
                        "v-card",
                        { attrs: { height: _vm.chatHeight } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "text-xs-center pt-5" },
                            [
                              _c("v-progress-circular", {
                                staticClass: "primary--text",
                                attrs: { indeterminate: "" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.visiteurs[0]
                    ? _c(
                        "div",
                        { attrs: { height: "100%" } },
                        [
                          _c(
                            "transition",
                            {
                              attrs: {
                                name: "slide-x-reverse-transition",
                                mode: "out-in"
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _vm.msg.anotherDay
                                    ? _c(
                                        "v-flex",
                                        {
                                          key: _vm.msg.date,
                                          staticClass: "text-xs-center sticky",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dateMessageChat",
                                              attrs: { secondary: "" }
                                            },
                                            [_vm._v(_vm._s(_vm.msg.anotherDay))]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.visiteurs[0].chats[0].messages,
                                    function(msg, i) {
                                      return _c(
                                        "v-flex",
                                        { key: i, attrs: { xs12: "" } },
                                        [
                                          msg.auteur == "Visiteur"
                                            ? _c(
                                                "v-layout",
                                                { attrs: { row: "" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "text-xs-right ma-2",
                                                      attrs: { xs2: "" }
                                                    },
                                                    [
                                                      _c("wz-avatar", {
                                                        attrs: {
                                                          username:
                                                            msg.agentName,
                                                          src:
                                                            _vm.domaine +
                                                            "/public/media/user/small/_avatar.jpg",
                                                          size: "35px"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.intentId === msg.id
                                                    ? _c(
                                                        "v-flex",
                                                        { attrs: { xs10: "" } },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            {
                                                              class: [
                                                                "white--text",
                                                                "histo__bubble",
                                                                "histo__bubble--agent",
                                                                "blue",
                                                                "pointer"
                                                              ],
                                                              nativeOn: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.changeSection.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-card-text",
                                                                {
                                                                  staticClass:
                                                                    "pa-2 ma-2"
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    msg.text
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                msg.text
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      staticClass:
                                                                        "font-italic text-right"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Intention à vérifier "
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        [
                                                                          _vm._v(
                                                                            "(cliquez pour éditer)"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              _vm._s(msg.date) +
                                                                " • " +
                                                                _vm._s(
                                                                  msg.type
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  msg.value
                                                                ) +
                                                                " • Entité : " +
                                                                _vm._s(
                                                                  msg.entity
                                                                )
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "v-flex",
                                                        { attrs: { xs10: "" } },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            {
                                                              class: [
                                                                "white--text",
                                                                "histo__bubble",
                                                                "histo__bubble--agent",
                                                                _vm.colorChatAgent,
                                                                "pointer"
                                                              ],
                                                              nativeOn: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  msg.text !==
                                                                    "tfstart" &&
                                                                    msg.text !==
                                                                      "tfstartwithcookie" &&
                                                                    _vm.changeDialogIntent(
                                                                      msg.id
                                                                    )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-card-text",
                                                                {
                                                                  staticClass:
                                                                    "pa-2 ma-2"
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    msg.text
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                msg.text
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      staticClass:
                                                                        "font-italic text-right"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          msg.comment
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              _vm._s(msg.date) +
                                                                " • " +
                                                                _vm._s(
                                                                  msg.type
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  msg.value
                                                                ) +
                                                                " • Entité : " +
                                                                _vm._s(
                                                                  msg.entity
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                  _vm._v(" "),
                                                  _c("v-flex", {
                                                    staticClass:
                                                      "hidden-sm-and-down",
                                                    attrs: { md3: "" }
                                                  })
                                                ],
                                                1
                                              )
                                            : _c(
                                                "v-layout",
                                                { attrs: { row: "" } },
                                                [
                                                  _c("v-flex", {
                                                    staticClass:
                                                      "hidden-sm-and-down",
                                                    attrs: { md3: "" }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "text-xs-right",
                                                      attrs: {
                                                        xs10: "",
                                                        md8: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          class: [
                                                            "white--text",
                                                            "histo__bubble",
                                                            "histo__bubble--visitor",
                                                            _vm.colorChatVisiteur
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-text",
                                                            {
                                                              staticClass:
                                                                "text-xs-right pa-2"
                                                            },
                                                            [
                                                              false
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "corner corner--visitor",
                                                                      attrs: {
                                                                        color:
                                                                          _vm.colorChatVisiteur,
                                                                        unselectable:
                                                                          "on",
                                                                        onselectstart:
                                                                          "return false;",
                                                                        onmousedown:
                                                                          "return false;"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "arrow_drop_down"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mr-4"
                                                                },
                                                                [
                                                                  msg.text
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatText(
                                                                                msg.text
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "img",
                                                                        {
                                                                          attrs: {
                                                                            src:
                                                                              msg.attachment,
                                                                            alt:
                                                                              "Image indisponible"
                                                                          }
                                                                        }
                                                                      )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(_vm._s(msg.date))
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs2: "",
                                                        "ml-1": ""
                                                      }
                                                    },
                                                    [
                                                      _c("wz-avatar", {
                                                        attrs: {
                                                          username:
                                                            "#" +
                                                            _vm.visitorSelected,
                                                          size: "35px"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-alert",
                        {
                          attrs: {
                            color: "blue",
                            icon: "info",
                            value: "true",
                            outline: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm._f("cap")(_vm.$tc("chats", 0))) +
                              "\n        "
                          )
                        ]
                      )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59a14396", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59a14396","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzConvTrainingBot.vue
// module id = null
// module chunks = 